import React, { ReactNode, useCallback, useState } from 'react';
import {
  CookieConsent,
  readConsentCookies,
  setConsentCookies,
} from 'src/services/cookieService';

export type TrackingContextType = {
  consent: CookieConsent | null;
  setConsent: (updatedConsent: CookieConsent) => void;
  trackingEnabled: boolean;
  setTrackingEnabled: (trackingEnabled: boolean) => void;
};

export const TrackingContext = React.createContext<TrackingContextType>({
  consent: null,
  setConsent: () => {
    throw Error('setConsent is called before TrackingProvider is initialized');
  },
  trackingEnabled: false,
  setTrackingEnabled: () => {
    throw Error(
      'setTrackingEnabled is called before TrackingProvider is initialized'
    );
  },
});

export const TrackingProvider = ({ children }: { children: ReactNode }) => {
  const [consent, setConsent] = useState<CookieConsent | null>(
    readConsentCookies
  );
  const [trackingEnabled, setTrackingEnabled] = useState<boolean>(false);

  const setConsentMemoized = useCallback((updatedConsent: CookieConsent) => {
    setConsentCookies(updatedConsent);
    setConsent(updatedConsent);
  }, []);

  return (
    <TrackingContext.Provider
      value={{
        consent,
        setConsent: setConsentMemoized,
        trackingEnabled,
        setTrackingEnabled,
      }}
    >
      {children}
    </TrackingContext.Provider>
  );
};
